<template>
    <div>
        <img class="empty-image" :src="emptyImage" />
        <h6 class="text-center">
            {{ caption }}
        </h6>
    </div>
</template>

<script>
import EmptySvg from '~/assets/img/empty.svg';

export default {
    name: 'NoContent',
    data: () => ({
        emptyImage: EmptySvg,
    }),
    props: {
        caption: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped>
.empty-image {
    width: 200px;
    height: 200px;
    object-fit: scale-down;
    display: block;
    margin: auto;
}
</style>
